export function applyExpandedChange(expanded, index, isExpanded) {
  return {
    ...expanded,
    [index]: isExpanded,
  };
}

export function applyPersonNameFilter(value) {
  return value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
}

export function applyPersonFieldChange(persons, index, field, filteredValue) {
  const updatedPersons = [...persons];
  updatedPersons[index] = {
    ...updatedPersons[index],
    [field]: filteredValue,
  };
  return updatedPersons;
}

export function applyAccordionsChanged(accordionsChanged, index) {
  return {
    ...accordionsChanged,
    [index]: true,
  };
}

export function applyInvalidFieldUpdate(invalidFields, index, field, isInvalid) {
  if (!invalidFields[index]) {
    return invalidFields;
  }
  return {
    ...invalidFields,
    [index]: {
      ...invalidFields[index],
      [field]: isInvalid,
    },
  };
}

export function clonePersons(persons) {
  return JSON.parse(JSON.stringify(persons));
}
